import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import axios from 'axios';

import Modal from 'kepler/lib/components/Modal';
import ModalBody from 'kepler/lib/components/ModalBody';
import { locationUpdate } from '../actions/action-contact-location';
import LogIn from '../components/LogIn';
import { closeModalContainer } from '../actions/action-login-modal';
import { resetStepUp } from '../actions/action-step-up';
import dispatchLogin from '../actions/action-login-redirect';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import i18n from '../../lib/reacti18n';
import { SELECT_RESULT } from '../constants/PropTypesShapes';
import { chatType, MODAL_TYPE } from '../constants/UtilVariables';
import Page from '../../lib/page';
import { initializeLiveChat, resetAllChatClicksInSession, wasChatBotClicked } from '../../lib/chat-bot-live-helper';
import {
  getPuiTopicConfig,
  isPUIIntentEnabled,
  requestPuiTopicValidation,
} from '../../lib/puiTopicHelper';
import { isLoggedOutChatCaptchaEnabled } from '../../lib/loggedOutChatHelper';

const CHANNEL_CHATBOT = chatType.chatBot;

const label = {
  confirm: i18n.message('smarthelp/chatBot.chatBot.error.ok'),
};

const loggedOutChatContent = {
  recoverPassword: i18n.message('smarthelp/messageUs.login.recoverPassword'),
  chatWithUs: i18n.message('smarthelp/messageUs.login.chatWithUsPasswordIssue'),
  loggedOutChatText: i18n.message('smarthelp/messageUs.login.messageText'),
};

class ModalContainer extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
  }

  // Send FPTi request when intermediate page open
  componentDidUpdate() {
    const topicId = this.props.topicRefId || _get(this.props.selectResult, 'topicTreeSelectResult.topicRefId');
    if (this.props.isModalOpen) {
      // In Email Page If Intent is enabled for DE Hardcoded webform page
      if (isPUIIntentEnabled(topicId) && this.props.isEmailPage) {
        // If logged out chat is enabled
        if (this.props.isLoggedOutChatEnabled) {
          return trackPage({ id: 'intermediatePage', link: `smarthelp-intermediate|open|messageUs|pui-email-page|${topicId}|logged-out-chat|link-shown` });
        }
        // If logged out chat is not enabled
        return trackPage({ id: 'intermediatePage', link: `smarthelp-intermediate|open|messageUs|pui-email-page|${topicId}` });
      }

      // For final intent Email link on the login modal
      if (isPUIIntentEnabled(topicId) && this.props.isPuiTopicEnabled) {
        return trackPage({ id: 'intermediatePage', link: `smarthelp-intermediate|open|${this.props.channel}|${this.getChannelTriggeredPoint()}|${topicId}|email-us-while-logged-out|link-shown` });
      }

      if (this.props.isLoggedOutChatEnabled) {
        trackPage({ id: this.props.FPTITrackerId, link: `smarthelp-intermediate|open|${this.props.channel}|${this.getChannelTriggeredPoint()}|logged-out-chat|link-shown` });
      } else {
        trackPage({ id: this.props.FPTITrackerId, link: 'smarthelp-intermediate|open' });
      }
    }
    return null;
  }

  getTopicRefId() {
    return _get(this.props.selectResult, 'topicTreeSelectResult.topicRefId');
  }

  getChannelTriggeredPoint() {
    const topicRefId = this.getTopicRefId();
    if (!_isEmpty(topicRefId)) {
      if (wasChatBotClicked()) {
        return 'botPill';
      }
      return 'finalContactChannel';
    }
    return 'defaultContactChannel';
  }

  showLoginPage() {
    let pathname = encodeURIComponent(window.location.pathname.slice(3));

    // if clicked on login from complaints page change the pathname to contact-us
    // so user will land into callus poage after login
    if (this.props.fromComplaintsPage) {
      pathname = '/smarthelp/contact-us';
    }

    // if clicked on message us icon from email page, add the endpoint during log out to login
    // So that user will land on the email page after login
    if (this.props.fromEmailPage) {
      pathname = `${window.location.pathname}${window.location.search}`;
    }

    const currentUri = `${Page.getOriginPath()}${pathname}`;
    const topic = {};

    const topicRefId = _get(this.props.selectResult, 'topicTreeSelectResult.topicRefId');
    const topicId = _get(this.props.selectResult, 'topicTreeSelectResult.topicId');
    const topicName = _get(this.props.selectResult, 'topicTreeSelectResult.topicName');
    if (topicRefId && topicId && topicName) {
      topic.topicId = topicId;
      topic.topicName = topicName;
      topic.topicRefId = topicRefId;
    }

    trackLink({ id: this.props.FPTITrackerId, link: `smarthelp-intermediate|login|${this.props.channel}` });
    return this.props.dispatchLogin(currentUri, this.props.channel, topic);
  }

  showGuestPage() {
    trackLink({ id: this.props.FPTITrackerId, link: `smarthelp-intermediate|guest|${this.props.channel}` });

    if (this.props.fromComplaintsPage) {
      // redirecting to contactus page for opening callus page
      return window.open('/smarthelp/contact-us', '_self');
    }
    return this.props.locationUpdate({ pageName: 'callUs' });
  }

  closeModal() {
    resetAllChatClicksInSession();
    trackLink({ id: this.props.FPTITrackerId, link: 'smarthelp-intermediate|close' });
    this.props.resetStepUp();
    this.props.requestPuiTopicValidation();
    return this.props.closeModalContainer();
  }

  cbOnClickChatLinkHandler() {
    trackPage({ id: this.props.FPTITrackerId, link: 'smarthelp-intermediate|autoClose|logged-out-chat' });
    trackLink({ id: this.props.FPTITrackerId, link: `smarthelp-intermediate|login-window|${this.props.channel}|${this.getChannelTriggeredPoint()}|logged-out-chat|link-clicked` });
    sessionStorage.removeItem('chatBotClicked');
    sessionStorage.removeItem('liveChatClicked');
    this.props.resetStepUp();
    this.props.closeModalContainer();

    // Remote config check for logout chat captcha
    const isLogOutChatCaptchaEnabled = isLoggedOutChatCaptchaEnabled();

    // If logout chat captcha in remote config is enabled make the axios call.
    if (isLogOutChatCaptchaEnabled) {
      return axios.get(('/smarthelp/enable-help-captcha')).then(() => {
        trackPage({ id: 'loggedOutChatCaptchaSuccess' });
        return initializeLiveChat(this.getTopicRefId());
      }).catch(() => trackPage({ id: 'loggedOutChatCaptchaError' }));
    }
    return initializeLiveChat(this.getTopicRefId());
  }

  cbOnEmailUsWhileLoggedOutClickHandler() {
    const redirectUrl = getPuiTopicConfig().redirectUrl || '/smarthelp/contact-us?email=payuponinvoice';
    // todo: insert correct fpti
    trackPage({ id: this.props.FPTITrackerId, link: 'smarthelp-intermediate|autoClose|email-us-while-logged-out' });
    trackLink({ id: this.props.FPTITrackerId, link: `smarthelp-intermediate|login-window|${this.props.channel}|${this.getChannelTriggeredPoint()}|email-us-while-logged-out|link-clicked` });
    window.open(redirectUrl, '_self');
    this.props.closeModalContainer();
  }

  // Render login prompt for selected Call/Email option in the logout cases
  renderLoginModal() {
    return (
      <LogIn
        content={this.props.content}
        channelType={this.props.channel}
        clickAction={() => this.showLoginPage()}
        linkAction={() => this.showGuestPage()}
        isLoggedOutChatEnabled={this.props.isLoggedOutChatEnabled}
        loggedOutChatClickHandler={() => this.cbOnClickChatLinkHandler()}
        puiTopicClickHandler={() => this.cbOnEmailUsWhileLoggedOutClickHandler()}
        isPuiTopicEnabled={this.props.isPuiTopicEnabled}
        loggedOutChatContent={loggedOutChatContent}
        fromComplaintsPage={this.props.fromComplaintsPage}
        topicRefId={this.props.topicRefId}
      />
    );
  }

  // Render/prompt message with the message of open message-type modal
  renderMessageModal() {
    return (
      <div className="text-center">
        <div className="login">{this.props.modalMessage}</div>
        <button className="login_btn btn" onClick={() => this.closeModal()}>{label.confirm}</button>
      </div>
    );
  }

  // Render Modal Prompt
  renderModalPrompt() {
    if (this.props.modalType !== MODAL_TYPE.message) {
      return this.renderLoginModal();
    }

    // Showing message type modal
    return this.renderMessageModal();
  }

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.isModalOpen}
          type="dialog"
          width="medium"
          role="contentinfo"
          onCancel={this.closeModal}
        >
          <ModalBody>
            {this.renderModalPrompt()}
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  // emailUs--> Intent selected and email--> No intent selected
  const channels = {
    email: 'emailUs',
    callUs: 'callUs',
    emailUs: 'emailUs',
    messageUs: 'messageUs',
    chatBot: CHANNEL_CHATBOT,
    chat: CHANNEL_CHATBOT,
  };
  return {
    content: i18n.message(`smarthelp/${channels[state.modal.channel]}`),
    isModalOpen: state.modal.isModalOpen,
    modalType: state.modal.type,
    modalMessage: state.modal.message,
    channel: state.modal.channel,
    selectResult: state.selectResult,
    isLoggedOutChatEnabled: state.modal.isLoggedOutChatEnabled,
    fromComplaintsPage: state.modal.fromComplaintsPage,
    isPuiTopicEnabled: state.modal.isPuiTopicEnabled,
    fromEmailPage: state.modal.fromEmailPage,
    topicRefId: state.emailNoIntent && state.emailNoIntent.kanaCode,
    isEmailPage: state.emailNoIntent && state.emailNoIntent.display,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    closeModalContainer, dispatchLogin, locationUpdate, resetStepUp, requestPuiTopicValidation,
  }, dispatch);
}

ModalContainer.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  locationUpdate: PropTypes.func.isRequired,
  dispatchLogin: PropTypes.func.isRequired,
  closeModalContainer: PropTypes.func.isRequired,
  content: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  channel: PropTypes.string.isRequired,
  selectResult: PropTypes.shape(SELECT_RESULT).isRequired,
  FPTITrackerId: PropTypes.string,
  modalType: PropTypes.string.isRequired,
  modalMessage: PropTypes.string.isRequired,
  resetStepUp: PropTypes.func.isRequired,
  requestPuiTopicValidation: PropTypes.func.isRequired,
  isPuiTopicEnabled: PropTypes.bool.isRequired,
  isLoggedOutChatEnabled: PropTypes.bool.isRequired,
  fromComplaintsPage: PropTypes.bool,
  topicRefId: PropTypes.string.isRequired,
  fromEmailPage: PropTypes.string.isRequired,
  isEmailPage: PropTypes.bool.isRequired,
};

ModalContainer.defaultProps = {
  content: {
    login: {
      guestMessage: '',
      header: '',
      instruction: '',
      login: '',
      loginMessage: '',
      message: '',
      trouble: '',
    },
  },
  FPTITrackerId: 'intermediatePage',
  fromComplaintsPage: false,
  isPuiTopicEnabled: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalContainer);
